export const LoomisColors = {
	red: '#E51837',
	darkRed: '#AC162C', // Används inte?
	lightBlue: '#00A3E3',
	blue: '#005C9B',
	darkBlue: '#28383E',
	darkerBlue: '#1E252B', // Textfärg
	yellow: '#F9B000',
	orange: '#EA5B0C',
	green: '#95C11F',
	darkGreen: '#2C8732',
	blueGrey: '#92A8B2',
	white: '#FFFFFF',
	lightestGrey: '#F8F8F8',
	lighterGrey: '#F2F2F2',
	lightGrey: '#E6E6E6',
	grey: '#D4D4D4',
	darkGrey: '#949C9F',
	black: '#000000',
}



// WEBPACK FOOTER //
// ./src/lib/LoomisColors.js